import loadable from '@loadable/component';

export const MembershipLinksLoadable = loadable(
  () => import('./MembershipLinks'),
  {
    resolveComponent: (module) => module.MembershipLinks,
  },
);
